<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>NUEVO TURNO</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <ion-item lines="full">
        <ion-label position="floating">NOMBRE TURNO</ion-label>
        <ion-input class="text-uppercase" v-model="turno.nombre"></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-label position="floating">MENSAJE</ion-label>
        <ion-textarea rows="4" v-model="turno.mensaje" placeholder="Ingrese un texto para mostrar..."></ion-textarea>
      </ion-item>

      <ion-item lines="full">
        <ion-label position="stacked">DÍA INICIO</ion-label>
        <select class="form-control mt-2" v-model="turno.inicio" cancel-text="CANCELAR" ok-text="ACEPTAR" @change="turno.fin=''">
          <option class="opt" value="" disabled selected>SELECCIONA UNO</option>
          <option class="opt" value="1">LUNES</option>
          <option class="opt" value="2">MARTES</option>
          <option class="opt" value="3">MIERCOLES</option>
          <option class="opt" value="4">JUEVES</option>
          <option class="opt" value="5">VIERNES</option>
          <option class="opt" value="6">SABADO</option>
          <option class="opt" value="7">DOMINGO</option>
        </select>
      </ion-item>
      <ion-item lines="full">
        <ion-label position="stacked">DÍA FIN</ion-label>
        <select class="form-control mt-2" :disabled="turno.inicio == ''" v-model="this.turno.fin" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <option class="opt" value="" disabled selected>SELECCIONA UNO</option>
          <option class="opt" v-if="turno.inicio <= 1" value="1">LUNES</option>
          <option class="opt" v-if="turno.inicio <= 2" value="2">MARTES</option>
          <option class="opt" v-if="turno.inicio <= 3" value="3">MIERCOLES</option>
          <option class="opt" v-if="turno.inicio <= 4" value="4">JUEVES</option>
          <option class="opt" v-if="turno.inicio <= 5" value="5">VIERNES</option>
          <option class="opt" v-if="turno.inicio <= 6" value="6">SABADO</option>
          <option class="opt" v-if="turno.inicio <= 7" value="7">DOMINGO</option>
        </select>
      </ion-item>

      <ion-item class="mt-3" lines="full">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12">
              <h6>CORREOS PARA INFORMAR</h6>
            </div>
            <div class="col">
              <div class="border rounded-pill py-1 px-2 mb-2" style="display:inline-flex; font-size:12px!important;" v-for="(correo,index) in turno.destinos" :key="'correo'+index">
                <span>{{correo}}<span @click="turno.destinos.splice(index,1);"><fa :icon="['fad', 'times']" class="fa-fw ml-2" style="cursor:pointer;"></fa> </span></span>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-7">
              <ion-input class="text-lowercase" type="email" slot="start" placeholder="ejemplo@mail.com" v-model="nuevoCorreo"></ion-input>
            </div>
            <div class="col-5 mt-1 text-right">
              <ion-button :disabled="!validaCorreo()" @click="turno.destinos.push(nuevoCorreo); nuevoCorreo='';" expand="block" shape="round"><fa :icon="['fad', 'plus']" class="fa-fw mr-1"></fa>AGREGAR</ion-button>
            </div>
          </div>
        </div>
      </ion-item>

      <ion-item class="mt-3" lines="full">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12">
              <h6>DÍAS PARA INFORMAR</h6>
            </div>
          </div>
          <div class="row mb-2 mt-2">
            <div class="col">
              <div @click="agragaDiaAlerta(index+1)" :class="{'alert-success': turno.alertas.indexOf(index+1) != -1, 'alert-light':turno.alertas.indexOf(index+1) == -1}" class="border rounded-pill py-1 px-2 mb-2 mr-2" style="display:inline-flex;cursor:pointer;" v-for="(dia,index) in inicialesDias" :key="'d'+index">
                <span>{{dia}}</span>
              </div>
            </div>
          </div>
        </div>
      </ion-item>

      <ion-item class="mt-3" lines="full">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12">
              <h6>MOSTRAR A</h6>
            </div>
            <div class="col">
              <div class="border rounded-pill py-1 px-2 mb-2" style="display:inline-flex; font-size:12px!important;" v-for="(tipo,index) in turno.mostrar" :key="'tipo'+index">
                <span>{{tipo.nombre}}<span @click="turno.mostrar.splice(index,1);"><fa :icon="['fad', 'times']" class="fa-fw ml-2" style="cursor:pointer;"></fa> </span></span>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-7">
              <ion-label position="stacked">TIPOS USUARIO</ion-label>
              <select class="form-control mt-2" v-model="nuevoTipo" cancel-text="CANCELAR" ok-text="ACEPTAR">
                <option class="opt" value="" disabled selected>SELECCIONA UNO</option>
                <option class="opt" v-show="turno.mostrar.indexOf(tipo) == -1" :value="tipo" v-for="tipo in tiposUsuario" :key="'tpu'+tipo.id">{{tipo.nombre}}</option>
              </select>
            </div>
            <div class="col-5 mt-1 pt-4 text-right">
              <ion-button :disabled="nuevoTipo==null" @click="turno.mostrar.push(nuevoTipo); nuevoTipo=null;" expand="block" shape="round"><fa :icon="['fad', 'plus']" class="fa-fw mr-1"></fa>AGREGAR</ion-button>
            </div>
          </div>
        </div>
      </ion-item>
      
      <ion-item class="mt-3" lines="full">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-7 mt-1">
              <h6>PERSONAS DEL TURNO</h6>
            </div>
            <div class="col-5 text-right">
              <ion-button @click="muestraModalBuscarUsuario();" expand="block" slot="end" shape="round" size="small"><fa :icon="['fad', 'edit']" class="fa-fw mr-1"></fa>MODIFICAR</ion-button>
            </div>
          </div>
          <div class="row mb-4 mt-3">     
            <div class="col-12 p-0">
              <ion-reorder-group v-if="turno.usuarios.length > 0" @ionItemReorder="reOrdenar($event)" :disabled="false">
                <ion-item v-for="usuario in turno.usuarios" :key="'per'+usuario.rut">
                  <h6 style="font-size:11px!important;">{{usuario.nombre}}</h6>
                  <ion-reorder slot="end"></ion-reorder>
                </ion-item>
              </ion-reorder-group>
              <h6 v-else class="text-secondary text-center my-3">SIN PERSONAS ASIGNADAS AL TURNO.</h6>
            </div>
          </div>
        </div>
      </ion-item>

    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="registrarTurno();" color="success" shape="round" expand="block">
                <ion-label>REGISTRAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonInput, IonSpinner, IonList, toastController, IonTextarea, IonReorderGroup, IonReorder } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline } from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';
import mBuscarUsuario      from '@/components/ModalBuscarUsuario.vue';

export default defineComponent({
  name: 'ModalNuevoTurno',
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonInput, IonSpinner, IonList, IonTextarea, IonReorderGroup, IonReorder },
  data(){
    const arreglo = [];
    return {
      cargando              : false,
      turno                 : {nombre:'', inicio:'', fin:'', mensaje:'', destinos:[], usuarios:[], alertas: arreglo, mostrar:[]},
      nuevoCorreo           : '',
      modalBuscarUsuario    : modalController,
      inicialesDias         : ['LU', 'MA', 'MI', 'JU', 'VI', 'SA', 'DO'],
      tiposUsuario          : [],
      nuevoTipo             : null
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
    this.listarTiposUsuarios();
  },
  methods:{
    agragaDiaAlerta(dia){
      if(this.turno.alertas.indexOf(dia) != -1){
        this.turno.alertas.splice(this.turno.alertas.indexOf(dia), 1);
      }
      else {
        this.turno.alertas.push(dia);
      }
    },

    reOrdenar(event){
      const aux = this.turno.usuarios[event.detail.from];
      this.turno.usuarios.splice(event.detail.from, 1);
      this.turno.usuarios.splice(event.detail.to, 0, aux);
      event.detail.complete();
    },

    async listarTiposUsuarios(){
      this.cargando = true;
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/turnos/listarTiposUsuarios', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        this.tiposUsuario = resp.data.tipos_usuario;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR TURNO.');
      });
    },

    async registrarTurno(){
      this.cargando = true;
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('turno', JSON.stringify(this.turno));
      axios.post(rutaBase+'/turnos/registrarTurno', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('DATOS REGISTRADOS CORRECTAMENTE.');
          this.cerrarModal({recargar:true});
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR TURNO.');
      });
    },

    async muestraModalBuscarUsuario(){
      const modalBuscarUsuario = await modalController
        .create({
          component: mBuscarUsuario,
          componentProps: {seleccionados: this.turno.usuarios},
          backdropDismiss: false
        });
      modalBuscarUsuario.present();
      const modalResponse = await modalBuscarUsuario.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      if(datos.usuarios){
        this.turno.usuarios = datos.usuarios;
      }
    },

    validaDatos(){
      if(
        this.turno.nombre          == '' ||
        this.turno.inicio          == '' ||
        this.turno.fin             == '' ||
        this.turno.mensaje         == '' ||
        this.turno.destinos.length == 0  ||
        this.turno.usuarios.length == 0  ||
        this.turno.alertas.length  == 0  ||
        this.turno.mostrar.length  == 0
      ){
        return false;
      }
      else {
        return true;
      }
    },

    validaCorreo(){
      const regCorreo = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)$/;
      if (regCorreo.test(this.nuevoCorreo)){
        return true;
      } 
      else {
        return false;
      }
    },

    async cerrarModal(dato={}){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>